// Access of the logged-in admin. The API computes the permissions of each
// admin (roles or custom permissions) and sends them with the session
// (`effectivePermissions`: { section: "none" | "view" | "edit" }). The API
// checks them again on every protected request: hiding a tab is only comfort.

const LEVELS = ["none", "view", "edit"];
const rank = (level) => Math.max(0, LEVELS.indexOf(level));

export const SUPERUSER_ROLES = ["super admin", "system admin"];

/** Event fired when the cached session changes (login, refresh). */
export const SESSION_EVENT = "afo:session";

export function currentSession() {
  try {
    return JSON.parse(localStorage.getItem("session")) || {};
  } catch (error) {
    return {};
  }
}

/** Roles of the logged-in admin, from the cached session. */
export function sessionRoles(session = currentSession()) {
  return Array.isArray(session.role) ? session.role : [];
}

export function isSuperuser(roles = sessionRoles()) {
  return roles.some((role) => SUPERUSER_ROLES.includes(role));
}

/** Permissions of the logged-in admin, by section. */
export function sessionPermissions(session = currentSession()) {
  return session.effectivePermissions || {};
}

/** Whether the admin has at least `level` ("view" or "edit") on `section`. */
export function can(section, level = "view", session = currentSession()) {
  if (isSuperuser(sessionRoles(session))) return true;
  return rank(sessionPermissions(session)[section]) >= rank(level);
}

/** Create, edit and delete in a content section (videos, series, podcasts, ads, channels…). */
export function canEditContent(section = "videos") {
  return can(section, "edit");
}

/** Content analytics (views, plays) on the detail pages. */
export function canViewAnalytics() {
  return can("analytics");
}
